import { Stack } from "@mui/joy";
import React from "react";
import Link from "components/common/Link";
import useGetUrls from "hooks/useGetUrls";
import useBottomSafePadding from "hooks/useBottomSafePadding";

export default function FullPageContainer({
  children,
  hasFooter,
  backgroundColor,
  disableBottomSafeArea = false,
}: {
  children: React.ReactNode;
  hasFooter?: boolean;
  backgroundColor?: string;
  disableBottomSafeArea?: boolean;
}) {
  const { companyInfoUrl, privacyPolicyUrl, servicePolicyUrl } = useGetUrls();
  // 페이지 단위 하단 안전영역: iOS 는 env(34) / Android in-app 은 12px breathing /
  // PC · Android Chrome 은 0px (visual 차이 없음).
  const safePb = useBottomSafePadding("0px");
  return (
    <Stack
      direction={"column"}
      alignItems="center"
      sx={{
        zIndex: 1000,
        position: "fixed",
        top: 0,
        width: "100vw",
        height: "calc(var(--vh,1vh) * 100)",
        minHeight: "calc(var(--vh,1vh) * 100)",
        backgroundColor: backgroundColor || "background.level1",
        pb: disableBottomSafeArea ? 0 : safePb,
      }}
    >
      {children}

      {hasFooter && (
        <Stack
          direction={"row"}
          spacing={"20px"}
          sx={{ pt: 1, wordBreak: "keep-all" }}
        >
          <Link
            opacity={100}
            bold={false}
            text={"사업자 정보"}
            url={companyInfoUrl}
          />
          <Link
            opacity={100}
            bold={false}
            text={"개인정보 처리방침"}
            url={privacyPolicyUrl}
          />
          <Link
            opacity={100}
            bold={false}
            text={"서비스 이용약관"}
            url={servicePolicyUrl}
          />
        </Stack>
      )}
    </Stack>
  );
}
